import { useMemo } from 'react';

import { Formatter } from '@atlas/base';
import { useApplicationState } from '@atlas/core';

import useLanguage from 'src/hooks/useLanguage';

const defaultLocale = 'en';

const useFormatter = (customCurrency = undefined) => {
  const { hreflang } = useLanguage();

  const {
    wallet: { currency },
  } = useApplicationState();

  return useMemo(() => {
    return Formatter.get({
      currency: customCurrency ?? currency,
      locale: hreflang ?? defaultLocale,
    });
  }, [hreflang, currency, customCurrency]);
};

export default useFormatter;
